import { post } from "./api";

/**
 * Destek oturumu (21ik ekibinin firma gözünden salt okunur bakışı) için istemci yardımcıları.
 * Panel, oturumu başlatınca dönüş adresini (`/yonetim/firmalar/:id`) bu sekmenin sessionStorage'ına yazar;
 * oturum bitince ya da düşünce kullanıcı giriş ekranı yerine panele döner.
 */
export const SUPPORT_RETURN_KEY = "hik:support-return";

export function supportReturnUrl(): string | null {
  try {
    const v = sessionStorage.getItem(SUPPORT_RETURN_KEY);
    return v && v.startsWith("/yonetim") ? v : null;
  } catch {
    return null;
  }
}

export function setSupportReturn(url: string) {
  try {
    sessionStorage.setItem(SUPPORT_RETURN_KEY, url);
  } catch {
    /* depolama kapalı: dönüş panel ana sayfasına olur */
  }
}

export function clearSupportReturn() {
  try {
    sessionStorage.removeItem(SUPPORT_RETURN_KEY);
  } catch {
    /* yok say */
  }
}

/** Şeritteki "Oturumu bitir": destek oturumunu kapatır ve tam yeniden yüklemeyle panele döner. */
export async function endSupportAndReturn() {
  const back = supportReturnUrl() ?? "/yonetim/firmalar";
  try {
    await post("/auth/logout");
  } finally {
    clearSupportReturn();
    window.location.assign(back);
  }
}
